module.exports = __webpack_public_path__ + "img/iconePedidosCancelado.fac086e8.png";